module.exports = __webpack_public_path__ + "img/744.8cf12d68.jpg";